import { render } from "./CompanyApplication.vue?vue&type=template&id=0a06690a&scoped=true&ts=true"
import script from "./CompanyApplication.vue?vue&type=script&lang=ts"
export * from "./CompanyApplication.vue?vue&type=script&lang=ts"

import "./CompanyApplication.vue?vue&type=style&index=0&id=0a06690a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a06690a"]])

export default __exports__